import React from 'react';

class SkipSsr extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      shouldRenderComponent: false
    };
  }

  componentDidMount () {
    this.setState({ shouldRenderComponent: true });
  }

  render () {
    const { children } = this.props;
    return this.state.shouldRenderComponent
      ? children
      : null;
  }
}

export default function withoutSsr (Component) {
  return props => (
    <SkipSsr>
      <Component {...props} />
    </SkipSsr>
  );
}
